export default __webpack_public_path__ + "static/media/tip_point_based_matching.b49cdd32.png";